import script from "./PropertyDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyDetails.vue?vue&type=script&setup=true&lang=js"

import "./PropertyDetails.vue?vue&type=style&index=0&id=457a13d4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457a13d4"]])

export default __exports__